module.exports = __webpack_public_path__ + "static/horus_02-b931599c1effbdb95e261a76180f3efb.jpg";